import { render, staticRenderFns } from "./TaskNavMenu.vue?vue&type=template&id=10838b82&scoped=true&"
import script from "./TaskNavMenu.vue?vue&type=script&lang=js&"
export * from "./TaskNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./TaskNavMenu.vue?vue&type=style&index=0&id=10838b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10838b82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList})
